import { Injectable } from "@angular/core";
import { NetworkHierarchyServiceResourceService, JsonHierarchyElement } from "@psnb/nwt-api";
import { Observable } from "rxjs";
import { HierarchyNode } from "../models/hierarchy-node";

@Injectable({
  providedIn: 'root'
})
export class GetHierarchyService {

  constructor(private getHierarchyService: NetworkHierarchyServiceResourceService) {

  }
  
  /** Initial data */
  initialData(): HierarchyNode[] {
    const mockData: JsonHierarchyElement[] = [];
    mockData.push({
      altName: 'Organizational Root',
      elementID: 1,
      name: 'Organizational Root'
    });
    return mockData.map(name => new HierarchyNode(name, 0, true, false, false, false, false));
  }

  getChildren(node: JsonHierarchyElement): Observable<JsonHierarchyElement[]> | undefined {
    return this.getHierarchyService.resourceNetworkHierarchyServiceResourceGetHierarchyChildrenElementsGET(node.elementID);
  }

  isExpandable(node: JsonHierarchyElement): boolean {
    if(node.hierarchyElementType === 'NODE') {
      return false;
    }
    return true;
  }
}